import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import withApp from '../../../core/provider/withApp'
// import { SidebarNavigation } from '@brainstud/schiphol-vtc-ui'
import { getNavigation } from '../'
import { routeTo } from '@brainstud/react-helpers'
// TODO get appRoutes from provider
import { appRoutes } from '../../../features'

class Sidebar extends React.Component {
  componentDidUpdate(props) {
    if(props.app.sidebar !== this.props.app.sidebar) {
      if(this.props.app.sidebar) {
        document.querySelector('html').classList.add('hide-scroll')
      } else {
        document.querySelector('html').classList.remove('hide-scroll')
      }
    }
  }

  render() {
    return (
      <SidebarNavigation
        location={this.props.history.location}
        list={this.props.list}
        open={this.props.app.sidebar}
        toggleSidebar={this.props.app.toggleSidebar} />
    )
  }
}

export default withRouter(withApp(connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const navigationIds = state.navigation.list.allIds
    const chapters = state.chapters.chapters.byId
    const lessons = state.chapters.lessons.byId
    const pages = state.pages.list.byId

    const nav = getNavigation(navigationIds, navigation, chapters, pages)

    const list = nav.reduce((acc, item) => {
      const newItem = {
        id: item.id,
        title: `${item.prefix}. ${item.label}`,
      }

      switch(item.type) {
        case 'chapter':
          const chapter = chapters[item.chapterId]

          newItem.url = routeTo(appRoutes, 'chapter', { chapter: chapter.slug })

          if(chapter.lessons.length > 0) {
            newItem.list = chapter.lessons.reduce((acc, lessonId) => {
              const lesson = lessons[lessonId]

              return acc.concat({
                id: lesson.id,
                title: lesson.title,
                url: routeTo(appRoutes, 'lesson', { chapter: chapter.slug, lesson: lesson.slug }),
              })
            }, [])
          }

          if(chapter.quizId) {
            newItem.list = newItem.list.concat({
              id: chapter.quizId,
              title: 'Oefentoets',
              url: routeTo(appRoutes, 'quiz', { chapter: chapter.slug }),
            })
          }
          break

        case 'page':
          const page = pages[item.pageId]

          newItem.url = routeTo(appRoutes, 'page', { page: page.slug })
          break

        case 'quiz':
          newItem.title = `${item.id}. Eindtoets`
          newItem.url = routeTo(appRoutes, 'endtest')
          break

        default:
      }

      return acc.concat(newItem)
    }, [])

    return { list }
  },
  () => ({}),
)(Sidebar)))
